import { type CSSProperties } from '@mantine/core'
import { Size, Typography } from '@front/model'

export const getFontSizeCssProps = <T extends keyof (typeof Typography)['size']>(
  size: T
): Pick<CSSProperties, 'fontSize' | 'lineHeight'> => {
  return {
    fontSize: Typography.size[size],
    lineHeight: `${Typography.line[size]}px`,
  }
}

export const defaultFormFieldLabel: CSSProperties = getFontSizeCssProps('sm')

export const defaultFormFieldWrapper: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  rowGap: Size.space.lg,
}

export const defaultFormFieldDescription: CSSProperties = getFontSizeCssProps('xs')

export const defaultFormFieldInputStyles = {
  root: defaultFormFieldWrapper,
  label: defaultFormFieldLabel,
  description: defaultFormFieldDescription,
}

export const PAGE_HEIGHT = 'h-[calc(100vh-(var(--app-shell-header-offset,0rem)+var(--app-shell-padding,0rem)*2))]'
